module.exports = __webpack_public_path__ + "static/media/get-involved-phillanthrophy-2.a9ba255c.jpg";